import { Routes, Route } from "react-router-dom";
import TelegramWebAppBootstrap from "./components/TelegramWebAppBootstrap.jsx";
import TelegramGiveawayDeepLink from "./components/TelegramGiveawayDeepLink.jsx";
import OfferConsentGate from "./components/OfferConsentGate.jsx";
import Layout from "./components/Layout.jsx";
import { ParticipateChromeProvider } from "./context/ParticipateChromeContext.jsx";
import { HeaderActionsProvider } from "./context/HeaderActionsContext.jsx";
import { LayoutTitleProvider } from "./context/LayoutTitleContext.jsx";
import HomePage from "./pages/HomePage.jsx";
import ProductPage from "./pages/ProductPage.jsx";
import ParticipateEntry from "./pages/ParticipateEntry.jsx";
import ProfilePage from "./pages/ProfilePage.jsx";
import ProfileActivePage from "./pages/ProfileActivePage.jsx";
import ProfileHistoryPage from "./pages/ProfileHistoryPage.jsx";
import ProfileLoginPage from "./pages/ProfileLoginPage.jsx";
import ProfileCompletePage from "./pages/ProfileCompletePage.jsx";
import SettingsPage from "./pages/SettingsPage.jsx";
import HelpPage from "./pages/HelpPage.jsx";
import PurchasesPage from "./pages/PurchasesPage.jsx";
import ShortGiveawayRedirect from "./pages/ShortGiveawayRedirect.jsx";

export default function App() {
  return (
    <TelegramWebAppBootstrap>
      <ParticipateChromeProvider>
        <HeaderActionsProvider>
          <LayoutTitleProvider>
            <Layout>
              <TelegramGiveawayDeepLink />
              <OfferConsentGate />
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/purchases" element={<PurchasesPage />} />
                <Route path="/profile/login" element={<ProfileLoginPage />} />
                <Route path="/profile/complete" element={<ProfileCompletePage />} />
                <Route path="/profile/active" element={<ProfileActivePage />} />
                <Route path="/profile/history" element={<ProfileHistoryPage />} />
                <Route path="/profile/settings" element={<SettingsPage />} />
                <Route path="/profile" element={<ProfilePage />} />
                <Route path="/help" element={<HelpPage />} />
                <Route path="/s/:code" element={<ShortGiveawayRedirect />} />
                <Route path="/giveaway/:id" element={<ProductPage />} />
                <Route path="/giveaway/:id/participate" element={<ParticipateEntry />} />
              </Routes>
            </Layout>
          </LayoutTitleProvider>
        </HeaderActionsProvider>
      </ParticipateChromeProvider>
    </TelegramWebAppBootstrap>
  );
}
